import React from 'react';

import Switch from '@components/uikit/Switch/Switch';

import useTranslation from '@hooks/useTranslation';

import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

import { selectAppPersistDarkMode, useAppPersistActions } from '@store/useAppStorePersist';

import style from './style.module.scss';

const ThemeBlock = () => {
  const { t } = useTranslation();

  const { isFetching: profileIsFetching } = useUserProfileQuery();

  const { setAppPersistDarkMode } = useAppPersistActions();

  const darkMode = selectAppPersistDarkMode();

  return (
    <div className={style.themeBlock}>
      <div className={style.themeBlockTitle}>{t('Theme')}</div>

      <div className={style.themeBlockContainer}>
        <div className={style.themeBlockDescr}>{t('Choose the appearance of your dashboard.')}</div>
        <Switch
          value={darkMode}
          onChange={() => setAppPersistDarkMode(!darkMode)}
          label={t('Dark Mode')}
          type="woHelperText"
          disabled={profileIsFetching}
        />
      </div>
    </div>
  );
};

export default ThemeBlock;
